import ApiError, { ApiErrorType } from './api/ApiError';
import {
    showAPINotImplementedNotification,
    showErrorNotificationWithMessage,
    showInternalErrorNotification,
    showInternalErrorWithUUIDNotification,
    showUnexpectedErrorNotification,
} from './notifications';

export default function postProcessApiResponse(response, logErrorMsgs = false) {
    if (response.responseStatus === 'SUCCESS') {
        return response.data;
    }

    if (response.responseStatus === 'FAILURE' && response.responseMessage && logErrorMsgs) {
        showErrorNotificationWithMessage(response.responseMessage);
        throw new ApiError(ApiErrorType.SERVER_ERROR);
    }

    if (!response.errors?.length && response.responseStatus === 'FAILURE') {
        if (response.responseMessage) {
            // eslint-disable-next-line no-console
            console.error(response.responseMessage);
        }
        showUnexpectedErrorNotification();
    }

    response.errors?.forEach((e) => {
        switch (e.type) {
            case 'INTERNAL_SERVER_ERROR':
                if (e.uuid) {
                    showInternalErrorWithUUIDNotification(e.uuid);
                } else {
                    showInternalErrorNotification();
                }
                break;
            case 'NOT_FOUND':
                showAPINotImplementedNotification();
                break;
            default:
                showUnexpectedErrorNotification();
                break;
        }
    });

    throw new ApiError(ApiErrorType.SERVER_ERROR);
}
